module.exports = __webpack_public_path__ + "img/partner10.906207db.png";